module.exports = __webpack_public_path__ + "static/scale-model-of-psycho-house-in-glendale-california-1297678e4177ad9ac00e4cba32ca98eb.png";